import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";
import { PageHero, Reveal, SectionTag } from "../components/Reveal";
import { RouteMap } from "../components/RouteMap";

const Cabotagem = () => {
  const { t } = useLanguage();
  const p = t.cabotage;

  return (
    <main data-testid="cabotage-page">
      <PageHero chip={p.chip} title={p.title} sub={p.sub} testid="cabotage-hero" />

      {/* mapa da rota */}
      <section className="px-6 lg:px-12 py-16 border-b border-ops">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <RouteMap />
          </Reveal>
        </div>
      </section>

      {/* itens + imagem */}
      <section className="px-6 lg:px-12 py-20 border-b border-ops bg-ops-panel/60">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {p.items.map((item, i) => (
              <Reveal key={item.title} delay={i * 0.08}>
                <div data-testid={`cabotage-item-${i}`} className="p-6 rounded-xl border border-ops bg-ops-surface h-full space-y-3 hover:border-ops-light/60 transition-colors">
                  <span className="font-display text-3xl font-extrabold text-ops-light/25">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display text-base font-bold uppercase text-white">{item.title}</h3>
                  <p className="text-xs text-ops-muted leading-relaxed">{item.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1} className="lg:col-span-6">
            <div className="rounded-2xl overflow-hidden border border-ops aspect-[4/3]">
              <img
                src={IMAGES.containerShip}
                alt="Navio de cabotagem de contêineres"
                data-testid="cabotage-ship-image"
                loading="lazy"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </Reveal>
        </div>
      </section>

      {/* papel do TUP */}
      <section className="px-6 lg:px-12 py-20">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <SectionTag>{p.roleTitle}</SectionTag>
          <Reveal>
            <p data-testid="cabotage-role-text" className="font-display text-2xl sm:text-3xl font-bold text-white leading-snug">
              {p.roleText}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <Link
              to="/contato"
              data-testid="cabotage-cta"
              className="inline-flex items-center gap-2 px-8 py-4 bg-ops-light text-ops-base text-xs font-display font-bold uppercase tracking-widest rounded hover:bg-white transition-colors"
            >
              {p.cta} <ArrowRight size={14} />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Cabotagem;
